import { Alert, Typography } from '@mui/material';
import { IEventScheduleChange } from '../../../interfaces/IEventScheduleChange';
import { formatRescheduleDateChange } from '../../../utils/rescheduleDateFormatter';

interface RescheduleNoticeProps {
    scheduleChange: IEventScheduleChange;
    onDismiss: () => void;
    refundGuidance: string;
}

export default function RescheduleNotice({
    scheduleChange,
    onDismiss,
    refundGuidance,
}: RescheduleNoticeProps) {
    return (
        <Alert severity="info" onClose={onDismiss} sx={{ borderRadius: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 700, mb: 0.5 }}>
                This event has been rescheduled
            </Typography>
            <Typography variant="body1">
                {formatRescheduleDateChange(scheduleChange)} {refundGuidance}
            </Typography>
        </Alert>
    );
}
